import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { View, Text } from "../_core/components";
import { Icon } from "../icon";
import { Input } from "../input";
import { useDefaultValue } from "../_util/use-default";
import { noop } from "../_util/noop";
import { useTranslation } from "../config-provider/i18n";
import { useConfig } from "../_util/use-config";
import { TaroEnv } from "../_util/env";
export var Search = forwardRef(function Search(props, ref) {
    var t = useTranslation();
    var classPrefix = useConfig().classPrefix;
    var _a = useDefaultValue(props), value = _a.value, _b = _a.placeholder, placeholder = _b === void 0 ? "请输入" : _b, disabled = _a.disabled, showCancel = _a.showCancel, hideIcon = _a.hideIcon, className = _a.className, onChange = _a.onChange, _c = _a.onSearch, onSearch = _c === void 0 ? noop : _c, _d = _a.onClear, onClear = _d === void 0 ? noop : _d, _e = _a.onCancel, onCancel = _e === void 0 ? noop : _e, restProps = __rest(_a, ["value", "placeholder", "disabled", "showCancel", "hideIcon", "className", "onChange", "onSearch", "onClear", "onCancel"]);
    var handleConfirm = function (e) {
        e.stopPropagation();
        onSearch(value);
    };
    var handleReset = function (event) {
        event.stopPropagation();
        onChange("", { event: event });
        onClear();
    };
    var handleCancel = function (event) {
        event.stopPropagation();
        onChange("", { event: event });
        onCancel();
    };
    return (React.createElement(View, { className: classNames(classPrefix + "-search", className, {
            "is-disabled": disabled,
        }) },
        !hideIcon && (React.createElement(Icon, { name: "search", className: "icon-search", onClick: handleConfirm })),
        React.createElement(Input, __assign({ ref: ref, className: classPrefix + "-search__input", placeholder: placeholder, value: value, confirmType: "search", disabled: disabled, onChange: onChange, onConfirm: handleConfirm }, restProps)),
        !!value && (React.createElement(Icon, { name: "close-fill", className: classPrefix + "-search__reset", size: TaroEnv ? 40 : 20, onClick: handleReset })),
        showCancel && (React.createElement(Text, { className: classPrefix + "-search__cancel", onClick: handleCancel }, t.cancelText))));
});
//# sourceMappingURL=Search.js.map